<template>
  <div class="feeD-con">
    <div class="infoItem">
      <p class="infoTit">学员信息</p>
      <p>姓名:<span>{{stuFeeInfo.name}}</span></p>
      <p>身份证号:<span>{{stuFeeInfo.idCard}}</span></p>
    
    </div>
    <div class="infoItem">
     <div class="noteBox">
        <img src="../assets/imgs/noteIcon.png" alt="">
        <span>请您认真核对即将购买课程</span>
     </div>
      <div class="clearfix studyBox">
        <div class="fl">
           <!-- 1出租车 2道路运输 3专项学习 4安全学习 5两类人员-->
                <img v-if="1===1" src="../assets/imgs/jxjyHome.png" alt="" class="cType">
                <img v-else-if="2===2" src="../assets/imgs/road.png" alt="" class="cType">
                <img v-else-if="3===3" src="../assets/imgs/zxxxHome.png" alt="" class="cType">
                <img v-else-if="4===4" src="../assets/imgs/wycHome.png" alt="" class="cType">
                <img v-else-if="5===5" src="../assets/imgs/llryHome.png" alt="" class="cType">
        </div>
        <div class="fl">
          <p class="studyType">{{stuFeeInfo.title}}</p>
          <p>有效期至:<span>{{stuFeeInfo.endDate}}</span></p>
        </div>
      </div>
      <!-- <p class="price">￥{{stuFeeInfo.money}}</p> -->
        <div class="infoTxt">
        注意：<span>购买后不支持退款、转让，请确认订单信息以及有效期</span>
      </div>
    <div class="relPay">
      实付:￥{{stuFeeInfo.money}}
    </div>
    <div
      class="btnToPay"
      @click="toPay"
    >支付</div>
    </div>
    
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import { getConfig, sendOrder, sureOrder } from '../../src/api/Api'
import wx from 'weixin-jsapi'
export default {
  data () {
    return {
      stuFeeInfo: {},
      planId:this.$route.query.planId
    }
  },
  created () {
    this.toSureOrder()
    console.log(this.planId);
  },
  mounted () {
    // let year=new Date().getFullYear()+1
    // let month=new Date().getMonth()+1
    // let day=new Date().getDate()
    // this.nextDate =year+'-'+month+'-'+day
  },
  methods: {
    toSureOrder () {
      sureOrder({
        courseId: this.planId
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.stuFeeInfo = res.data.returnDate
          this.getConfig()
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    getConfig () {
      console.log('configconfigconfig' + window.location.href)
      var url = window.location.href
      getConfig({
        url: url
      }).then(res => {
        if (res.data.returnCode === 1) {
          var data = res.data.returnDate // 将解密后的字符串转为对象  Decrypt这里是解密，不需要的就直接过滤悼
          console.log(data)
          // 下列的data.均为后台接口返回的字段，比如我的项里里返回的是 appid,timestamp,nonceStr,signature
          wx.config({
            // debug: 'false', // 这里一般在测试阶段先用ture， 上线时删掉
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.noncestr,
            signature: data.signature,
            jsApiList: ['chooseWXPay']
          })
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['chooseWXPay'],
              success: function (res) {
                console.log('seccess')
                console.log(res)
              },
              fail: function (res) {
                console.log('fail')
                console.log(res)
              }
            })
          })
        } else {
          Toast(res.data.returnDate)
        }
      })
    },
    // 缴费
    toPay () {
      var $this = this
      sendOrder({
        goodsId: this.planId
      }).then(res => {
        console.log('@@@@' + res.data.returnCode)
        if (res.data.returnCode === 1) {
          var data = res.data.returnDate.resBody // 将解密后的字符串转为对象
          console.log(res)
          console.log('dedede' + data.packageval)
          wx.ready(function () {
            wx.chooseWXPay({
              appId: data.appid,
              timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: data.nonceStr, // 支付签名随机串，不长于 32
              package: data.packageval, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: data.paySign, // 支付签名
              success: function (res) {
                // 跳转到支付成功页面有这个页面
                // $this.$router.push({
                //     path: "/success_page",
                //     name:"success_page"
                // })
                Toast('支付成功')
                console.log(res + '支付成功')
                $this.$router.replace({
                  path: '/'
                })
              },
              cancel: function (res) {
                // 提示引用的是mint-UI里toast
                console.log(res + 'wwww')
                Toast('已取消支付')
              },
              fail: function (res) {
                Toast('支付失败，请重试')
              }
            })
          })
        } else {
          Toast({
            message: '获取支付信息失败，请重试'
          })
        }
      })
    }
  }
}
</script>
<style lang="">
#app .feeD-con {
  background: #fff;
  height: auto;
}
.noteBox{
  margin-bottom: 0.2rem;
  color: #999;
  font-size: 0.14rem;
}
.btnToPay{
  width: 2.6rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  border-radius: 0.4rem;
  background: #92B8FE;
  margin:0  auto 0.6rem;
}
.noteBox img{
  width: 0.34rem;
  height: 0.34rem;
  vertical-align: middle;
}
.studyBox img{
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.18rem;
}
.studyBox p,.studyBox p span{
  color: #999;
  font-size: 0.13rem;
}
.feeD-con .noteBox span{
  font-size: 0.2rem;
  color: #F39938;
  margin-left: 0.06rem;
}
.infoTxt{
  color: #ED4D3D;
  font-size: 0.16rem;
  margin-top: 0.6rem;
}
.infoTxt span{
  color: #333;
}
.infoItem {
  padding: 0.3rem 0.4rem;
  border-bottom: 0.2rem solid #f1f1f1;
}
.infoTit {
  font-size: 0.3rem;
  color: #666;
}
.infoItem {
  color: #666;
  line-height: 0.6rem;
}
.infoItem span {
  color: #333;
  margin-left: 0.2rem;
}
.price {
  border-top: 1px solid #f1f1f1;
  text-align: right;
  color: #4172cc;
  padding-top: 0.2rem;
  margin-top: 0.2rem;
}
.relPay {
  color: #4172cc;
  text-align: center;
  padding: 0.6rem;
}
.studyBox p.studyType{
  font-size: 0.4rem;
  color: #333;
  font-family: '黑体';
}
</style>



// WEBPACK FOOTER //
// src/views/ToPay.vue